import { iconFactory } from '../iconFactory'

export const Close = iconFactory(
  'Close',
  ({ fill }) => (
    <path
      d="M16.9497475,5.63603897 L18.363961,7.05025253 L13.414039,12.000039 L18.363961,16.9497475 L16.9497475,18.363961 L12.000039,13.414039 L7.05025253,18.363961 L5.63603897,16.9497475 L10.586039,12.000039 L5.63603897,7.05025253 L7.05025253,5.63603897 L12.000039,10.586039 L16.9497475,5.63603897 Z"
      transform="translate(12.000000, 12.000000) rotate(-360.000000) translate(-12.000000, -12.000000) "
      fill={fill}
    />
  ),
  { viewBox: '0 0 24 24', height: '24px', width: '24px' },
)
